import { render, staticRenderFns } from "./index.vue?vue&type=template&id=60b1c70a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=60b1c70a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1c70a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b1c70a')) {
      api.createRecord('60b1c70a', component.options)
    } else {
      api.reload('60b1c70a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=60b1c70a&scoped=true&", function () {
      api.rerender('60b1c70a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/App/BucketNavBar/index.vue"
export default component.exports